import { Stethoscope } from "lucide-react";

const PhoneHeart = () => (
  <svg
    viewBox="0 0 48 48"
    className="h-10 w-10"
    aria-hidden="true"
    fill="none"
  >
    <rect
      x="13"
      y="4"
      width="22"
      height="40"
      rx="6"
      stroke="#FF6257"
      strokeWidth="3"
    />
    <path
      d="M24 27.8l-4.2-4.2a3 3 0 0 1 4.2-4.3 3 3 0 0 1 4.2 4.3L24 27.8z"
      fill="#FF6257"
    />
    <path
      d="M20.5 38.5h7"
      stroke="#FF6257"
      strokeWidth="3"
      strokeLinecap="round"
    />
  </svg>
);

function Item({ icon, heading, copy, bg, separator, testid }) {
  return (
    <div
      className={`relative flex items-center gap-5 py-2 md:flex-col md:items-center md:px-4 md:text-center lg:flex-row lg:justify-center lg:gap-5 lg:px-3 lg:text-left xl:gap-6 ${
        separator
          ? "border-t border-[#F0CCC2] pt-6 md:border-t-0 md:pt-2"
          : ""
      }`}
      data-testid={testid}
    >
      {separator && (
        <span
          aria-hidden="true"
          className="absolute left-0 top-1/2 hidden h-[64%] w-px -translate-y-1/2 bg-[#F0CCC2] md:block"
        />
      )}
      <div
        className={`flex h-[80px] w-[80px] shrink-0 items-center justify-center rounded-full md:h-[92px] md:w-[92px] xl:h-[100px] xl:w-[100px] ${bg}`}
      >
        {icon}
      </div>
      <div className="min-w-0 lg:max-w-[215px] xl:max-w-[250px]">
        <h3 className="text-[22px] font-extrabold leading-tight text-brand-ink xl:text-[24px]">
          {heading}
        </h3>
        <p className="mt-1 text-[18px] font-medium leading-[1.35] text-brand-ink lg:text-[19px] xl:text-[20px]">
          {copy}
        </p>
      </div>
    </div>
  );
}

export default function FeatureStrip() {
  return (
    <section aria-label="Who SympTrack helps" className="relative z-10">
      <div className="symp-container">
        <div
          className="grid grid-cols-1 gap-2 rounded-[28px] bg-[#FDF4EE] px-6 py-7 shadow-[0_18px_44px_rgba(7,88,102,0.08)] sm:px-8 md:grid-cols-3 md:gap-0 md:rounded-[32px] md:px-6 md:py-8 lg:min-h-[190px] lg:px-8 lg:py-6"
          data-testid="feature-strip"
        >
          <Item
            testid="feature-patients"
            icon={<PhoneHeart />}
            bg="bg-[#FDDFD8]"
            heading="Patients"
            copy={
              <>
                Capture the day
                <br />
                as it happens.
              </>
            }
          />
          <Item
            testid="feature-sophie"
            separator
            icon={
              <img
                src="/images/logo-mark.png"
                alt=""
                width="418"
                height="419"
                className="h-[76px] w-[76px]"
              />
            }
            bg="bg-transparent"
            heading="Sophie"
            copy={
              <>
                Organizes change
                <br />
                into a clearer story.
              </>
            }
          />
          <Item
            testid="feature-care-teams"
            separator
            icon={
              <Stethoscope
                className="h-10 w-10 text-brand-teal"
                aria-hidden="true"
              />
            }
            bg="bg-brand-aqua/60"
            heading="Care teams"
            copy={<>Review the context without digging through everything.</>}
          />
        </div>
      </div>
    </section>
  );
}
